import React from 'react'

import Attachment from "../../../../../model2/attachment/attachment"

type Props = {
    className?      : string
    attachment      : Attachment
    onPreviewClick? : callback
}

export default function AttachmentButtonPreview(props: Props) {

    if (!props.attachment) return null

    const onClick = (e:any) => {
        e.stopPropagation();

        if (!props.onPreviewClick) return

        props.onPreviewClick(props.attachment);
    };

    const classes = Classes("ui5-ico-round i5-eye", props.className)

    return (
        <div className={classes} onClick={onClick} />
    );
}
